module.exports = "/_next/static/images/apperance_ramen-840c6ba2659504dee9b09202ae8fd148.jpg";